import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EAppEventName } from '@core-constants/app-event-names.const';
import { EStepsUrls } from '@core-constants/step.const';
import { StepsDataService } from '@core-data-services/steps.data-service';
import { CheckoutManager } from '@core-managers/checkout.manager';
import { TokenManager } from '@core-managers/token.manager';
import { UserTokenStorage } from '@shared-base/generic-clases.base';
import { BroadcastService } from '@shared-services/broadcast.service';
import { Observable, of } from 'rxjs';
import { catchError, map, share } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ValidBillingAndPaymentStepGuard 
{
  constructor(private router: Router,
    public stepsDataService: StepsDataService,
    public tokenManager: TokenManager,
    public checkoutManager: CheckoutManager) { }

  public canActivate(): any
  {
    const orderId: number = this.tokenManager.getOrderId();

    if (orderId)
    {
      return this.returnToStep1();
    }

    const user: UserTokenStorage = this.tokenManager.getUser();
    const cartItemCount: number = this.checkoutManager.cartItemsCount;

    if (user && cartItemCount > 0)
    {
      return this.stepsDataService.$validateBillingAndPayment()
        .pipe(share(), catchError((response: HttpErrorResponse) =>
        {
          const error: string = response?.error?.message;

          BroadcastService.Instance.broadcast(EAppEventName.OnValidCart, error);

          return of(false);

        }),
          map((response) =>
          {
            return response ? true : this.returnToStep1();
          }));
    }
    else
    {
      return this.returnToStep1();
    }
  }

  public returnToStep1(): Observable<boolean>
  {
    this.router.navigate([EStepsUrls.Step1]);
    return of(false);
  }
}
